var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"small-font"},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.disclaimer_bold))]),_vm._v(" "+_vm._s(_vm.disclaimer_regular))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }